import { CompanyTitledPage } from "../../TitledPage";


import { SAMPLE_CUSTOMER_SEND_GROUP_LIST } from "../../../common/SampleData"

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { Link, useNavigate } from "react-router-dom";

import { SYSTEM_PATH_COMPANY } from "../../../App";
import { CompanyPartHeader } from "../../../components/PartHeader";


const getCustomerSendGroupLocationState = (customerSendGroupId) => {
  return { customerSendGroupId: customerSendGroupId }
}


function CustomerSendGroupTable() {

  const customerSendGroupList = SAMPLE_CUSTOMER_SEND_GROUP_LIST.filter((data) => data.delete_flag === false);
  const navigate = useNavigate();

  const onClickGroupEdit = (customerSendGroupId) => (event) => {
    navigate(
      SYSTEM_PATH_COMPANY + "/customer_send_group_edit",
      { state: getCustomerSendGroupLocationState(customerSendGroupId) }
    );
  }


  if (customerSendGroupList.length > 0) {
    return (
      <TableContainer component={Box}>
        <Table>
          <TableBody>
            {
              customerSendGroupList.map((data, i) => (
                <TableRow key={i}>
                  <TableCell width={30}>
                    <Typography fontSize={18} textAlign="right">{(i + 1).toString()}</Typography>
                  </TableCell>
                  <TableCell>
                    <Grid container alignItems="center" spacing={1}>
                      <Grid item xs>
                        <Typography fontSize={20}>
                          <Link
                            to={SYSTEM_PATH_COMPANY + "/customer_send_group_member_shops"}
                            state={getCustomerSendGroupLocationState(data.customer_send_group_id)}
                          >
                            {data.name}
                          </Link>
                        </Typography>
                      </Grid>
                      <Grid item xs="auto">
                        <Button variant="outlined" onClick={onClickGroupEdit(data.customer_send_group_id)}>グループ編集</Button>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <Typography>検索条件に該当する店舗がありません</Typography>
  )
}


export default function CustomerSendGroupListPage() {

  const navigate = useNavigate();

  const onClickCustomerSendGroupRegistration = (event) => {
    navigate(SYSTEM_PATH_COMPANY + "/customer_send_group_registration");
  }

  return (
    <CompanyTitledPage title="取引先送信グループ一覧">
      <CompanyPartHeader>
        <Grid container>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>取引先送信グループ一覧</Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickCustomerSendGroupRegistration}>新規取引先送信グループ登録</Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      <CustomerSendGroupTable />
    </CompanyTitledPage>
  )
};